import React from 'react';
import { Box, FormControl } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { LabelText, datePickerSlotProps, arrowButtonSx } from './styled';
import { IconButton } from '@mui/material';
import Icons from '../icons';

interface CustomDatePickerProps {
  label: string;
  value: any;
  onChange: (newValue: any) => void;
  format?: string;
  required?: boolean;
  disabled?: boolean;
  formControlMargin?: 'dense' | 'normal' | 'none' | undefined;
  width?: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  value,
  onChange,
  format = 'MMM DD, YYYY',
  required,
  disabled,
  formControlMargin = 'dense',
  width = '200px'
}) => {
  return (
    <Box>
      {label && <LabelText required={required}>{label}</LabelText>}
      <FormControl
        fullWidth
        required={required}
        disabled={disabled}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          mt: '6px',
          mb: '0px',
          width: width
        }}
        margin={formControlMargin}
      >
        <DatePicker
          value={value}
          onChange={onChange}
          format={format}
          disabled={disabled}
          slots={{
            openPickerIcon: Icons.Calendar,
            previousIconButton: (props) => (
              <IconButton {...props} sx={arrowButtonSx}>
                <Icons.CaretLeft />
              </IconButton>
            ),
            nextIconButton: (props) => (
              <IconButton {...props} sx={arrowButtonSx}>
                <Icons.CaretRight />
              </IconButton>
            )
          }}
          slotProps={datePickerSlotProps}
          sx={{ height: '40px' }}
        />
      </FormControl>
    </Box>
  );
};

export default CustomDatePicker;
